import React, { useState} from 'react';
import {Button, Dialog, DialogContent, DialogTitle, } from "@material-ui/core";
import DialogContentText from "@material-ui/core/DialogContentText";
import {useSelector} from "react-redux";
import {BRCustomizedTooltip as Tooltip} from "../accents/BRCustomizedTooltip";
import CloseIcon from '@material-ui/icons/Close';
import IconButton from "@material-ui/core/IconButton";
import BBIconFullscreen from "../../../assets/bbCustomIcons/BBIconFullscreen";
import PropTypes from "prop-types";


/**
 * Summary. FullScreenComponentDialog
 *
 * Description. Creates a button using the given icon and present the given component full screen.
 *
 * @param {object}      props              See definition
 *
 * @example {
 *
 *
 * }
 * **/
const FullScreenComponentDialog = (props) => {

    const {
        buttonIcon = <BBIconFullscreen/>,
        componentToDisplay = <></>,
    } = props;

    const {customers, customerInView} = useSelector(({customer}) => customer);

    // const {entityInView, portfolios, loadingCycles} = useSelector(({breachrisk}) => breachrisk);
    //
    // const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    //
    // const dispatch = useDispatch();
    //
    // const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);
    // const cycleHistory = myEntity && myEntity.history ? myEntity.history.slice(1) : null;

    const [open, setOpen] = useState(false);
    // const [cycleInView, setCycleInView] = useState(null);
    // const [cycleObj, setCycleObj] = useState(null);
    //
    // const breachRiskScore = (myEntity && cycleInView && cycleObj) ? parseFloat(cycleObj.summary.score).toFixed(1) : null;
    // const breachRiskCategory = (myEntity && cycleInView && cycleObj) && bbTranslateBreachRiskScoreToCategory(breachRiskScore);

    // let cycleObj = myEntity && cycleInView && myEntity.cycles ? myEntity.cycles.cycleInview : null;

    // useEffect(()=>{
    //     if(cycleInView && myEntity && !myEntity.cycles[cycleInView]){
    //         dispatch(fetchRiskCycleReport({
    //             customerId: customerIdToUse,
    //             cycleId: cycleInView
    //         }))
    //
    //         setCycleObj(myEntity.cycles[cycleInView]);
    //     }
    //
    //     if(myEntity && myEntity.cycles[cycleInView] && !cycleObj){
    //         setCycleObj(myEntity.cycles[cycleInView]);
    //     }
    //
    //     if(cycleInView && !cycleObj){
    //         setCycleObj(myEntity.cycles[cycleInView]);
    //     }
    //
    // }, [cycleInView])

    const handleOpen = () =>{
        setOpen(true);
        // setCycleInView(myEntity && myEntity.cycles && myEntity.settings && myEntity.settings.last_cycle_id ? myEntity.settings.last_cycle_id : null)
        // setCycleObj(myEntity && myEntity.cycles && myEntity.settings && myEntity.settings.last_cycle_id ? myEntity.cycles[myEntity.settings.last_cycle_id] : null)
    }

    const handleClose = () => {
        setOpen(false);
        // setCycleInView(null);
        // setCycleObj(null);
    }

    const handleOnClick = (value) => {
        // setCycleInView(value);
        //
        // if(cycleInView && myEntity && !myEntity.cycles[cycleInView]){
        //     dispatch(fetchRiskCycleReport({
        //         customerId: customerIdToUse,
        //         cycleId: cycleInView
        //     }))
        //
        //     setCycleObj(myEntity.cycles[cycleInView]);
        // }
        // setCycleObj(myEntity.cycles[value]);
    }

    // if(cycleInView && !cycleObj){
    //     setCycleObj(myEntity.cycles[cycleInView]);
    // }

    return(
        <div>
            <Tooltip title={"Fullscreen"}>
                <span>
                    <Button
                        variant="outlined"
                        color="default"
                        onClick={handleOpen}
                    >
                {buttonIcon}
            </Button>
                </span>
            </Tooltip>


            <Dialog open={open}
                    fullScreen
                    maxWidth={"xl"}
                    onClose={handleClose}
                    aria-labelledby="form-dialog-title">
                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                    <div className={"row"}>
                        {/*<div className={"col-5 text-center"}>*/}
                        {/*    <h1>Viewing Report Date {cycleInView && cycleObj*/}
                        {/*        ? bbFormattedDateString(cycleObj.summary.cycle_datetime, "shortFullMonth")*/}
                        {/*        : ""}</h1>*/}
                        {/*</div>*/}

                        {/*<div className={"col-6 p-0 m-0"}>*/}
                        {/*    {cycleHistory && cycleHistory.length > 1 ?*/}
                        {/*        <Select*/}
                        {/*            options={cycleHistory.map((cycle)=>{*/}
                        {/*                return {*/}
                        {/*                    label: bbFormattedDateString(cycle.cycle_date, "shortFullMonth"),*/}
                        {/*                    value: cycle.cycle,*/}
                        {/*                }}*/}
                        {/*            )}*/}
                        {/*            onChange={(value)=> handleOnClick(value.value)}/>*/}

                        {/*        : <em>No Past Reports Available</em>}*/}
                        {/*</div>*/}
                        <div className={"col-11"}/>

                        <div className={"col-1 text-right"}>
                            {/*<IconButton*/}
                            {/*    // variant={"s"}*/}
                            {/*    // color={"lightest-gray"}*/}
                            {/*    onClick={()=>window.print()}>*/}
                            {/*    <BBIconPrinterOutput/>*/}
                            {/*    /!*PRINT*!/*/}
                            {/*</IconButton>*/}

                            <IconButton
                                // variant={"s"}
                                // color={"lightest-gray"}
                                onClick={()=>handleClose()}>
                               <CloseIcon/>
                            </IconButton>
                        </div>
                    </div>
                </DialogTitle>
                <DialogContent>
                        <DialogContentText>
                            <div className={"border-2 p-3 bg-lightest-gray"}>
                                <div style={{height: '90%'}}>
                                    {componentToDisplay}
                                </div>
                            </div>

                    </DialogContentText>
                    <div className={"text-center m-1"}  style={{fontSize: "smaller"}}>
                        <p>©2019-2021 BreachBits, Inc. BreachRisk and other marks are servicemarks or trademarks of BreachBits, Inc. </p>
                        <p>1125 West Street, Suite 429, Annapolis, MD, 21401, (443) 440-5605.</p>
                        <p>Disclaimer: BreachBits is a third-party cybersecurity assessment firm; services rendered are not a substitute for a dedicated information security team.
                        Risk assessments that may appear in this report are a professional recommendation and are not a guarantee of your risk from data breaches, theft, destruction, degradation or other malicious activities.
                        By using BreachBits subscriptions, pilots, demonstrations, and other services, you acknowledge that no amount of security actions or red team activities can discover all possible vulnerabilities and/or eliminate all risk.
                        Many factors contribute to cybersecurity risk, and many of these factors are beyond the control of your organization - and beyond the scope of any BreachBits risk assessment. The risk of malicious cyber activity can never be zero;
                        your organization is always at risk from malicious cyber actors. For more information regarding the BreachBits limits of liability, please refer to your <a href={"https://www.breachbits.com/sla"}>Service Level Agreement.</a></p>
                        </div>
                    </DialogContent>

            </Dialog>
            <div className={"col-3"}/>
        </div>
    )
}
FullScreenComponentDialog.propTypes = {
    buttonIcon: PropTypes.element,
    componentToDisplay: PropTypes.element,
};

export default FullScreenComponentDialog;